var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},_vm._l((_vm.oauthOperators),function(ref){
var id = ref.id;
var name = ref.name;
return _c('div',{key:id,staticClass:"list__item"},[_c('button',{ref:("recaptcha-" + id),refInFor:true,class:("link link--" + id)},[_c('div',{staticClass:"link__img"},[_c('img',{attrs:{"src":require(("@/assets/png/sign-up/" + id + ".png"))}})]),_c('div',{staticClass:"link__text"},[_vm._v(_vm._s(_vm.action)+" with "+_vm._s(name))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }